import React, { ReactNode, createContext, useState } from "react";
import { useSelector } from "react-redux";

import {
  getChatProfile,
  getComposingHomie,
} from "../../../selectors/chat/chat";

import ChatHeader from "../shared/ChatHeader";
import { BackToRootButton } from "../shared/BackButton";
import QuickChatSelect from "./QuickChatSelect";
import ChatRoomSettingsButton from "./ChatRoomSettingsButton";
import Chat from "./Chat";
import MessageComposer from "./MessageComposer";
import DragDropWrapper from "components/chat/ChatRoom/DragDropWrapper";

export const DragDropContext = createContext<{
  setIsModalOpen: (isOpen: boolean) => void;
}>({
  setIsModalOpen: () => {},
});

function ChatWrapper({
  chatId,
  children,
}: {
  chatId: string;
  children: ReactNode;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (window.isApp) {
    return <div className="chat__container">{children}</div>;
  } else {
    return (
      <DragDropWrapper chatId={chatId} isModalOpen={isModalOpen}>
        <DragDropContext.Provider value={{ setIsModalOpen }}>
          {children}
        </DragDropContext.Provider>
      </DragDropWrapper>
    );
  }
}

export default function ChatRoom({ chatId }: { chatId: string }) {
  const composingHomie = useSelector((state) =>
    getComposingHomie(state, { chatId }),
  );

  const { name } = useSelector((state) => getChatProfile(state, { chatId }));
  return (
    <ChatWrapper chatId={chatId}>
      <ChatHeader
        title={name}
        subtitle={
          composingHomie
            ? chatId.indexOf("member/") === 0
              ? I18n.t("js.chat.room.somebody_is_typing")
              : I18n.t("js.chat.room.member_is_typing", {
                  name: composingHomie.name,
                })
            : ""
        }
        chatId={chatId}
        ButtonLeft={<BackToRootButton chatId={chatId} />}
        ButtonRight={<ChatRoomSettingsButton chatId={chatId} />}
      />
      <Chat id={chatId} />
      <div>
        <MessageComposer chatId={chatId} />
        <QuickChatSelect chatId={chatId} />
      </div>
    </ChatWrapper>
  );
}
